import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Booking } from 'src/app/shared/models/booking.model';
import { Therapy } from 'src/app/shared/models/therapy.model';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-practitioner-booking-item',
  templateUrl: './practitioner-booking-item.component.html',
  styleUrls: ['./practitioner-booking-item.component.scss']
})
export class PractitionerBookingItemComponent implements OnInit {
  @Input() booking: Booking;
  @Output() completed: EventEmitter<Booking> = new EventEmitter();

  emailIcon = faEnvelope;
  phoneIcon = faPhone;

  constructor() { }

  ngOnInit(): void {
  }

  getTherapyNames(therapies: Therapy[]): string {
    return Therapy.getTherapyNames(therapies);
  }

  markAsCompleted(): void {
    this.booking.isCompleted = true;
    this.completed.next(this.booking);
  }

}
